module.exports = __webpack_public_path__ + "static/img/DESKDAF.114966c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/DESKDAF.jpg
// module id = 663
// module chunks = 42